import { API_CONFIG } from '@/lib/api/config';

/**
 * Rewrites backend-generated image URLs to use the correct API base URL.
 *
 * The backend may return URLs with its internal origin (e.g. `http://localhost/storage/...`)
 * which differs from the actual reachable backend URL configured in `NEXT_PUBLIC_API_URL`.
 * This helper replaces the origin for `/storage/` paths so Next.js Image can load them.
 */
export function getImageUrl(
  url: string | null | undefined
): string | undefined {
  if (!url) return undefined;

  // Relative paths are fine as-is
  if (url.startsWith('/')) return url;

  try {
    const parsed = new URL(url);
    const apiBase = new URL(API_CONFIG.baseURL);

    // Only rewrite URLs that point to a /storage/ path (backend-generated)
    if (parsed.pathname.startsWith('/storage/')) {
      return `${apiBase.origin}${parsed.pathname}`;
    }

    return url;
  } catch {
    return url;
  }
}
